<template>
    <main loadingactive="[object Object]">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/change-password" aria-current="page"
                        class="router-link-exact-active router-link-active" id="'breadcrumb0"><span
                            to="">Account</span></a></li>
                <li class="breadcrumb-item"><span to="">Password</span></li>
            </ol>
        </nav>
        <div>
            <h1>Change Password</h1>
            <div class="section-group col-lg-6 col-md-7 col-sm-10">
                <form class="forms-sample">
                    <div class="mb-4">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group row"><label for="username" class="col-4 col-form-label"
                                        style="font-weight: bold;">Username</label>
                                    <div class="col-8"><input type="text" id="username" v-model="getUser.username" name="username"
                                            disabled="disabled" class="form-control"></div>
                                </div>
                                <div class="form-group row"><label for="password" class="col-4 col-form-label"
                                        style="font-weight: bold;"> Old Password <span class="required">★</span></label>
                                    <div class="col-8"><input v-model="old_password" @keyup.enter="ChangePassword()" id="password" name="password" placeholder="Old Password"
                                            required="required" type="password" class="form-control"><span
                                            toggle="#password" class="toggle-password field-icon"><i
                                                class="far fa-eye"></i></span></div>
                                </div>
                                <div class="form-group row"><label for="newPassword" class="col-4 col-form-label"
                                        style="font-weight: bold;"> New Password <span class="required">★</span></label>
                                    <div class="col-8"><input v-model="password" @keyup.enter="ChangePassword()" id="newPassword" name="newPassword"
                                            placeholder="New Password" required="required" type="password"
                                            class="form-control"><span toggle="#newPassword"
                                            class="toggle-password field-icon"><i class="far fa-eye"></i></span><small
                                            class="text-muted form-text">Enter only number (0-9) or letter (A-Z, a-z).</small></div>
                                </div>
                                <div class="form-group row"><label for="confirmPassword" class="col-4 col-form-label"
                                        style="font-weight: bold;"> Confirm Password <span
                                            class="required">★</span></label>
                                    <div class="col-8"><input  v-model="confirm_password" @keyup.enter="ChangePassword()" id="confirmPassword" name="confirmPassword"
                                            placeholder="Confirm Password" required="required" type="password"
                                            class="form-control"><span toggle="#confirmPassword"
                                            class="toggle-password field-icon"><i class="far fa-eye"></i></span><small
                                            class="text-muted form-text">Enter only number (0-9) or letter (A-Z, a-z).</small></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4" style="text-align: center;"><button type="button" @click="ChangePassword()" id="change-password"
                            value="Save New Password" class="btn btn-yellow ripple-parent mr-2"> Save New Password
                        </button></div>
                </form>
            </div>
        </div>
    </main>
</template>

<script>
import api from '../services/index.js'
import Swal from "sweetalert2";
import { mapGetters } from 'vuex'

export default {
    name: "ChangePassword",
    data() {
        return {
            old_password: "",
            password: "",
            confirm_password: ""
        };
    },
    computed: {
        ...mapGetters(["getUser"]),
    },
    methods: {
        async ChangePassword() {
      if (this.old_password == "" || this.password == "" || this.confirm_password == "") {
        Swal.fire("แจ้งเตือน", "ข้อมูลไม่ควรมีช่องว่าง", "warning");
        return;
      }
      await api.put('/change-password',{
          old_password: this.old_password,
          password: this.password,
          confirm_password: this.confirm_password
        })
        .then((obj) => {
          if (obj.success == true) {
            Swal.fire("Password changed Successfully.", "", "success");
          } else {
            Swal.fire("แจ้งเตือน", obj.error.message, "error");
          }
        })
        .catch((e) => {
          Swal.fire("แจ้งเตือน", e.response.data.error.message, "error");
        });
    }
    },
};
</script>